import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

class Layout_two_small_one_big  extends Layout_base {
  render() {
    return (
      <Col xs={12}>
        {this.sectionHead()}
        <Row>
          <Col sm={3}>{this.componentDOM(0)}</Col>
          <Col sm={3}>{this.componentDOM(1)}</Col>
          <Col sm={6}>{this.componentDOM(2)}</Col>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_two_small_one_big;
